export default function FloatingLineButton() {
  return (
    <a 
      href="https://lin.ee/MJ3LVM2" 
      target="_blank"
      rel="noopener noreferrer"
      className="floating-line-btn flex items-center space-x-2 text-white font-medium whitespace-nowrap cursor-pointer"
    >
      <div className="w-6 h-6 flex items-center justify-center">
        <i className="ri-line-fill text-xl"></i>
      </div>
      <span>LINE 相談</span>
    </a>
  );
}